import { PayoutResult } from "types/enums";
import { z } from "zod";

export const schema = z.object({
    id: z.string(),
    result: z.nativeEnum(PayoutResult).optional(),
    amount: z.number().optional().nullable(),
    affiliate_payout_id: z.string().optional().nullable(),
    affiliate_amount: z.number().optional().nullable(),
});

export type TransactionReportEditFormData = z.infer<typeof schema>;
